/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Starter
 */
export interface Starter {
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    showId?: number;
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    startNo?: number;
    /**
     * 
     * @type {string}
     * @memberof Starter
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Starter
     */
    horseRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Starter
     */
    riderRegisterId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    horseId?: number;
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    riderId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Starter
     */
    bookingDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof Starter
     */
    totalPrice?: number;
}

/**
 * Check if a given object implements the Starter interface.
 */
export function instanceOfStarter(value: object): value is Starter {
    return true;
}

export function StarterFromJSON(json: any): Starter {
    return StarterFromJSONTyped(json, false);
}

export function StarterFromJSONTyped(json: any, ignoreDiscriminator: boolean): Starter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'showId': json['showId'] == null ? undefined : json['showId'],
        'startNo': json['startNo'] == null ? undefined : json['startNo'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'horseRegisterId': json['horseRegisterId'] == null ? undefined : json['horseRegisterId'],
        'riderRegisterId': json['riderRegisterId'] == null ? undefined : json['riderRegisterId'],
        'horseId': json['horseId'] == null ? undefined : json['horseId'],
        'riderId': json['riderId'] == null ? undefined : json['riderId'],
        'bookingDate': json['bookingDate'] == null ? undefined : (new Date(json['bookingDate'])),
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
    };
}

export function StarterToJSON(json: any): Starter {
    return StarterToJSONTyped(json, false);
}

export function StarterToJSONTyped(value?: Starter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'showId': value['showId'],
        'startNo': value['startNo'],
        'bookerId': value['bookerId'],
        'horseRegisterId': value['horseRegisterId'],
        'riderRegisterId': value['riderRegisterId'],
        'horseId': value['horseId'],
        'riderId': value['riderId'],
        'bookingDate': value['bookingDate'] == null ? undefined : ((value['bookingDate']).toISOString()),
        'totalPrice': value['totalPrice'],
    };
}

